import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const locationRoutes = {
    GET_LIST_PROVINCES_AND_CITIES: "global/list/list-provinces-and-cities",
}
export default {
    listProvincesAndCities() {
        return new Promise(resolve => {
            let newData = [];
            http.get(locationRoutes.GET_LIST_PROVINCES_AND_CITIES)
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron las ciudades");
                        return;
                    }
                    if (code < 0) {
                        toast.error("Error al consultar las ciudades");
                        return;
                    }
                    const devices = data.info;
                    newData = data.info;
                    this.processOption(devices);
                    newData = devices;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    processOption(devices) {
        devices.forEach(value => {
                value.id = value.code;
                value.label = value.title;
                value.name = value.title;
            }
        );
    },
}